import { FC } from 'react';
import FormGroup from 'components/form/FormGroup';
import Form from 'components/form/Form';
import { IInputs, IDropdowns } from './types';

interface IProps {
  methods: any;
  handleSubmit: (data: IInputs) => void;
  btnLabel: string;
  userDataOptions: IDropdowns;
}

const UserForm: FC<IProps> = ({ methods, handleSubmit, btnLabel, userDataOptions }: IProps) => {
  return (
    <Form
      methods={methods}
      onSubmit={handleSubmit}
      btnLabel={btnLabel}
      isHorizontal
    >
      <FormGroup
        controlId="formGroupFirstName"
        label="Име"
        type="text"
        name="first_name"
        isRequired
        isHorizontal
      />
      <FormGroup
        controlId="formGroupLastName"
        label="Фамилия"
        type="text"
        name="last_name"
        isRequired
        isHorizontal
      />
      <FormGroup
        controlId="formGroupEmail"
        label="E-mail"
        type="email"
        name="email"
        isRequired
        isHorizontal
      />
      <FormGroup
        controlId="formGroupStatus"
        label="Статус"
        type="select"
        as="select"
        name="account_status"
        isRequired
        isHorizontal
        selectOptions={userDataOptions.account_status}
      />
    </Form>
  );
};

export default UserForm;
